import React from "react";
import { FaPhoneAlt, FaWhatsapp, FaEnvelope, FaClock } from "react-icons/fa";

import "./ContactInfo.css";

function ContactInfo() {
  const contactItems = [
    {
      icon: <FaPhoneAlt />,
      title: "Call Us",
      value: "+971 504 07 2475",
      link: "tel:971504072475",
    },
    {
      icon: <FaWhatsapp />,
      title: "WhatsApp",
      value: "Chat With Our Team",
      link: "https://wa.me/971504072475",
    },
    {
      icon: <FaEnvelope />,
      title: "Email Us",
      value: "info@mobilefixuae.com",
      link: "mailto:info@mobilefixuae.com",
    },
    {
      icon: <FaClock />,
      title: "Working Hours",
      value: "9:00 AM - 10:00 PM",
      link: null,
    },
  ];

  return (
    <section className="contact-info-section">
      <div className="container">
        <div className="section-heading text-center" data-aos="fade-up">
          <span className="section-badge">Contact Information</span>

          <h2 className="section-title">We're Here To Help</h2>

          <p className="section-description">
            Reach out to us through your preferred method and we'll get back to
            you as quickly as possible.
          </p>
        </div>

        <div className="row">
          {contactItems.map((item, index) => (
            <div
              className="col-lg-3 col-md-6 col-12 mb-3"
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="contact-info-card">
                <div className="contact-info-icon">{item.icon}</div>

                <div className="contact-info-content">
                  <h4>{item.title}</h4>

                  {item.link ? (
                    <a
                      href={item.link}
                      target={item.title === "WhatsApp" ? "_blank" : undefined}
                      rel="noopener noreferrer"
                    >
                      {item.value}
                    </a>
                  ) : (
                    <p>{item.value}</p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ContactInfo;
